import { useDashboardToAddToFromParam } from '@modules/analysis/hooks';
import { ArrowBackRounded } from '@mui/icons-material';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

export const GoBackToDashboardButton = () => {
  const navigate = useNavigate();
  const { state: locationState } = useLocation();
  const { context } = useDashboardToAddToFromParam();
  const {
    dashboardName,
    dashboardEmoji,
    dashboardContext: dashboardContextState,
  } = locationState || {};

  const dashboardContext = context || dashboardContextState;

  if (!dashboardName || !dashboardEmoji) {
    return null;
  }

  const onBackClick = () => {
    navigate(-1);
  };

  const getBackButtonLabel = () => {
    if (dashboardContext === 'Home') {
      return 'Home';
    }

    if (dashboardContext === 'Customize Home') {
      return 'Customize Home';
    }

    return backToDashboard;
  };

  const backToDashboard = (
    <Stack overflow="hidden" maxWidth={250} maxHeight={45}>
      <Stack spacing={0.5} direction="row">
        {dashboardEmoji && <Box>{dashboardEmoji}</Box>}
        <Typography variant="subtitle2" color="primary" noWrap>
          {dashboardName}
        </Typography>
      </Stack>
      <Stack alignItems="flex-start" ml={3} mt={-0.5}>
        <Typography variant="caption" color="text.secondary">
          Dashboard
        </Typography>
      </Stack>
    </Stack>
  );

  return (
    <Stack direction="row" spacing={1}>
      <Button
        variant="text"
        onClick={onBackClick}
        startIcon={<ArrowBackRounded />}
        sx={{ textTransform: 'none' }}
      >
        {getBackButtonLabel()}
      </Button>
      <Divider
        orientation="vertical"
        style={{
          height: '60px',
          marginRight: '8px',
          transform: 'rotate(15deg)',
        }}
      />
    </Stack>
  );
};
